import { useState, useEffect } from 'react';

/**
 * Hook customizado para adicionar um delay mínimo ao skeleton loader
 * Garante que o skeleton seja exibido por pelo menos X ms, criando uma transição suave
 */
export const useSkeletonDelay = (isLoading: boolean, minDelay: number = 1000) => {
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [startTime] = useState(Date.now());

  useEffect(() => {
    if (!isLoading) {
      const elapsed = Date.now() - startTime;
      const remainingDelay = Math.max(0, minDelay - elapsed);

      const timer = setTimeout(() => {
        setShowSkeleton(false);
      }, remainingDelay);

      return () => clearTimeout(timer);
    } else {
      setShowSkeleton(true);
    }
  }, [isLoading, minDelay, startTime]);

  return showSkeleton || isLoading;
};
